/* 用户登录态相关 */
//登录态
export const SET_SESSION_OBJ = "SET_SESSION_OBJ"
//cgi请求初始化
export const SET_CGI_OBJ = "SET_CGI_OBJ"
//用户头像
export const SET_USER_AVATAR = "SET_USER_AVATAR"
//用户昵称
export const SET_USER_NICKNAME = "SET_USER_NICKNAME"
//用户类型
export const SET_ACCOUNT_TYPE = "SET_ACCOUNT_TYPE"

/* 发票相关 */
//可申请发票的交易流水
export const SET_ENABLE_INVOICE_LIST = "SET_ENABLE_INVOICE_LIST"
//一年内的交易流水（包括不可开发票的）
export const SET_YEAR_INVOICE_LIST = "SET_YEAR_INVOICE_LIST"
//申请开发票的原始总金额（包括部分退款的）
export const SET_INVOICE_TOTAL_ORIGIN_PRICE = "SET_INVOICE_TOTAL_ORIGIN_PRICE"
//申请开发票的总金额
export const SET_INVOICE_TOTAL_PRICE = "SET_INVOICE_TOTAL_PRICE"
//用户填写的不同发票类型的抬头条目
export const SET_INVOICE_TITLE_ITEMS = "SET_INVOICE_TITLE_ITEMS"
//抬头条目填写错误的错误提示
export const SET_INVOICE_ITEMS_ERRTIP = "SET_INVOICE_ITEMS_ERRTIP"
//选择的发票类型
export const SET_INVOICE_TYPE = "SET_INVOICE_TYPE"
//选择的发票形式类型：电子or纸质
export const SET_INVOICE_FORM_TYPE = "SET_INVOICE_FORM_TYPE"
//当前选择的发票类型的tab
export const SET_INVOICE_TAB = "SET_INVOICE_TAB"
//当前类型下的发票信息填写完整,可以提交
export const SET_ENABLE_COMMIT = "SET_ENABLE_COMMIT"
//选择的需要开发票的订单
export const SET_SELECTED_INVOICE = "SET_SELECTED_INVOICE"
//选择的需要开发票的订单id列表
export const SET_SELECTED_INVOICE_CFTIDS = "SET_SELECTED_INVOICE_CFTIDS"
//当前发票信息
export const SET_CURRENT_INVOICE_INFO = "SET_CURRENT_INVOICE_INFO"
// 对已选择发票分主体
export const SET_SELECTED_CLASSIFICATION = "SET_SELECTED_CLASSIFICATION"
// 去除发票list
export const SET_DEL_SELECTED_CLASSIFICATION = "SET_DEL_SELECTED_CLASSIFICATION"

/* ui相关 */
//弹窗内容
export const SET_TOAST_MSG = "SET_TOAST_MSG"
